import { render, staticRenderFns } from "./language.vue?vue&type=template&id=4600fd14"
import script from "./language.vue?vue&type=script&lang=js"
export * from "./language.vue?vue&type=script&lang=js"
import style0 from "./language.vue?vue&type=style&index=0&id=4600fd14&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4600fd14')) {
      api.createRecord('4600fd14', component.options)
    } else {
      api.reload('4600fd14', component.options)
    }
    module.hot.accept("./language.vue?vue&type=template&id=4600fd14", function () {
      api.rerender('4600fd14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/announcement/language.vue"
export default component.exports